module.exports = __webpack_public_path__ + "static/media/logo.e32942ed.svg";